// extracted by css-extract-rspack-plugin
export default {"button":"_8723c6f6"};